import dayjs from "dayjs";
import { Dispatch } from "react";
import DateRangePicker from "../../../../../components/DatePickers/DateRangePicker/DateRangePicker";
import { D2DOrdersActions, setFilterAction } from "../../reducers/actions";
import { D2DOrdersFilters } from "../../types";

type D2DOrderDatePickerProps = {
  filters: D2DOrdersFilters;
  dispatch: Dispatch<D2DOrdersActions>;
};

// DateRangePicker sets a fixed input width, so "&&" is needed to shrink it into the column
const dateRangePickerSx = {
  width: "100%",
  "&& .MuiInputBase-input": {
    width: "100%",
    minWidth: 0,
    textOverflow: "ellipsis",
  },
};

const D2DOrderDatePicker = ({ filters, dispatch }: D2DOrderDatePickerProps) => (
  <DateRangePicker
    label=""
    dateRangeCalendarProps={{
      disableFuture: true,
      minDate: dayjs().subtract(1, "year"),
    }}
    enableShortcuts
    textFieldProps={{ sx: dateRangePickerSx }}
    onChange={([from, to]) => {
      dispatch(
        setFilterAction({
          ...filters,
          dateRequestedFrom: from,
          dateRequestedTo: to,
        })
      );
    }}
    value={[filters.dateRequestedFrom ?? null, filters.dateRequestedTo ?? null]}
  />
);

export default D2DOrderDatePicker;
